import { CandidateDialogModel } from './Models/CandidateDialogModel';
import { ApplicantRecruitmentOverviewResponse } from '@/Models/CandidateOverview';

export function mapFromCandidateOverviewToCandidateDialogModel(
    assessmentId: string,
    overview: ApplicantRecruitmentOverviewResponse,
): CandidateDialogModel {
    return {
        ...overview,
        assessmentId,
        name: overview.candidateFullName,
        status: overview.applicantStatus,
    };
}
